/**
 * Default scoring configuration for tournaments.
 * Points to win: 11 or 21 per game.
 * Serves per rotation: 2 or 5 (switch server after this many points).
 */
export const DEFAULT_SCORING_CONFIG = {
  singlesPointsToWin: 21,
  doublesPointsToWin: 21,
  singlesServesPerRotation: 2,
  doublesServesPerRotation: 2
};

/** Deuce starts when total points in game reaches (pointsToWin - 1) * 2 (e.g. 20-20 → 40, 10-10 → 20). */
export function getDeuceTotalPoints(pointsToWin) {
  return (pointsToWin - 1) * 2;
}

/** Get points to win and serves per rotation for a match type from tournament scoring config. */
export function getScoringOptionsForMatchType(scoringConfig, matchType) {
  const config = scoringConfig || DEFAULT_SCORING_CONFIG;
  const pointsToWin = matchType === 'doubles' ? (config.doublesPointsToWin ?? 21) : (config.singlesPointsToWin ?? 21);
  const servesPerRotation = matchType === 'doubles' ? (config.doublesServesPerRotation ?? 2) : (config.singlesServesPerRotation ?? 2);
  return { pointsToWin, servesPerRotation };
}
